import { createContext, ReactNode } from 'react';

interface TableContextValues {
    stickyHeader?: boolean;
    focusedRowIndexRef: { current: number };
    isRuled?: boolean;
    listenKeyEvents: boolean;
    onRowChange?: (rowIndex: number, event?: KeyboardEvent | MouseEvent) => void;
    setBodyNode: (node: ReactNode) => void;
    tableBodyNode?: HTMLElement;
    dispatchRowChangedEvent: (newRowIndex: number, didKeyboardNav: boolean) => void;
}

export const TableContext = createContext<TableContextValues>({
    dispatchRowChangedEvent: () => undefined,
    focusedRowIndexRef: { current: -1 },
    listenKeyEvents: false,
    setBodyNode: () => undefined,
});
